
import * as rootypes from './mutations_type';
// import Vue from 'vue';
// import {getStore} from "../config/mUtils";

export default {
    async actionTouchScreen({commit}, data) {
      commit(rootypes.RECODE_TOUCHSCREEN,data);
    },
  async actionCountDownNum({commit}, data) {
    commit(rootypes.COUNTDOWNNUM,data);
  },

}
